(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'UserProfile'];

    function UserManagementDetailController ($stateParams, User, UserProfile) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
                vm.user.userProfile = UserProfile.getByUserId({"id":vm.user.id});
            });
        }
    }
})();
